// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestLmnPopup-module__font-s-10___dFAhz {
  font-size: 10px !important;
}

.RequestLmnPopup-module__font-s-12___iI771 {
  font-size: 12px !important;
}

.RequestLmnPopup-module__font-s-13___Jxykm {
  font-size: 13px !important;
}

.RequestLmnPopup-module__font-s-14___wmuua {
  font-size: 14px !important;
}

.RequestLmnPopup-module__font-s-15___AQCuv {
  font-size: 15px !important;
}

.RequestLmnPopup-module__font-s-16___pU_V1 {
  font-size: 16px !important;
}

.RequestLmnPopup-module__font-s-18___yyqpA {
  font-size: 18px !important;
}

.RequestLmnPopup-module__font-s-20___JQFTF {
  font-size: 20px !important;
}

.RequestLmnPopup-module__font-s-22___YjXM7 {
  font-size: 22px !important;
}

.RequestLmnPopup-module__font-s-28___wZVj5 {
  font-size: 28px !important;
}

.RequestLmnPopup-module__font-w-400___TXbmn {
  font-weight: 400 !important;
}

.RequestLmnPopup-module__font-w-500___sTMX7 {
  font-weight: 500 !important;
}

.RequestLmnPopup-module__font-w-600___UXlQ6 {
  font-weight: 600 !important;
}

.RequestLmnPopup-module__font-w-700___ZbTq9 {
  font-weight: 700 !important;
}

.RequestLmnPopup-module__p-5___Mi_et {
  padding: 5px !important;
}

.RequestLmnPopup-module__p-12___tSaZV {
  padding: 12px !important;
}

.RequestLmnPopup-module__p-16___JGsEg {
  padding: 16px !important;
}

.RequestLmnPopup-module__p-30___qPvSH {
  padding: 30px !important;
}

.RequestLmnPopup-module__p-b-0___c9VLg {
  padding-bottom: 0 !important;
}

.RequestLmnPopup-module__p-b-5___Q06KB {
  padding-bottom: 5px !important;
}

.RequestLmnPopup-module__p-b-10___khcQJ {
  padding-bottom: 10px !important;
}

.RequestLmnPopup-module__p-b-12___zlfYd {
  padding-bottom: 12px !important;
}

.RequestLmnPopup-module__p-b-16___a_CCo {
  padding-bottom: 16px !important;
}

.RequestLmnPopup-module__p-b-18___UpclB {
  padding-bottom: 18px !important;
}

.RequestLmnPopup-module__p-b-20___esDls {
  padding-bottom: 20px !important;
}

.RequestLmnPopup-module__p-b-25___yS9kL {
  padding-bottom: 25px !important;
}

.RequestLmnPopup-module__p-b-30___pQp_r {
  padding-bottom: 30px !important;
}

.RequestLmnPopup-module__p-b-50___JOcHK {
  padding-bottom: 50px !important;
}

.RequestLmnPopup-module__p-t-0___ULhGW {
  padding-top: 0 !important;
}

.RequestLmnPopup-module__p-t-12___JajYj {
  padding-top: 12px !important;
}

.RequestLmnPopup-module__p-t-16___vujxy {
  padding-top: 16px !important;
}

.RequestLmnPopup-module__p-t-18___VhtrW {
  padding-top: 18px !important;
}

.RequestLmnPopup-module__p-t-20___KRYCb {
  padding-top: 20px !important;
}

.RequestLmnPopup-module__p-t-30___t9qR4 {
  padding-top: 30px !important;
}

.RequestLmnPopup-module__p-t-40___E09mv {
  padding-top: 40px !important;
}

.RequestLmnPopup-module__p-t-50___aN5qo {
  padding-top: 50px !important;
}

.RequestLmnPopup-module__p-l-20___X91B7 {
  padding-left: 20px !important;
}

.RequestLmnPopup-module__p-l-30___wpY0_ {
  padding-left: 30px !important;
}

.RequestLmnPopup-module__p-l-40___SbmPs {
  padding-left: 40px !important;
}

.RequestLmnPopup-module__p-r-16___Fk5UQ {
  padding-right: 16px !important;
}

.RequestLmnPopup-module__p-r-20____Awkt {
  padding-right: 20px !important;
}

.RequestLmnPopup-module__p-r-30___yTT21 {
  padding-right: 30px !important;
}

.RequestLmnPopup-module__p-r-50___LqQEg {
  padding-right: 50px !important;
}

.RequestLmnPopup-module__p-r-60___w8rXt {
  padding-right: 60px !important;
}

.RequestLmnPopup-module__m-b-1___kwF08 {
  margin-bottom: 1px !important;
}

.RequestLmnPopup-module__m-b-2___jRQF9 {
  margin-bottom: 2px !important;
}

.RequestLmnPopup-module__m-b-6___qtXhE {
  margin-bottom: 6px !important;
}

.RequestLmnPopup-module__m-b-8___qqKma {
  margin-bottom: 8px !important;
}

.RequestLmnPopup-module__m-b-10___FZkCI {
  margin-bottom: 10px !important;
}

.RequestLmnPopup-module__m-b-14___Dnoru {
  margin-bottom: 14px !important;
}

.RequestLmnPopup-module__m-b-16___cHTaf {
  margin-bottom: 16px !important;
}

.RequestLmnPopup-module__m-b-20___ALVhy {
  margin-bottom: 20px !important;
}

.RequestLmnPopup-module__m-b-22___nx93H {
  margin-bottom: 22px !important;
}

.RequestLmnPopup-module__m-b-24___PQYb5 {
  margin-bottom: 24px !important;
}

.RequestLmnPopup-module__m-b-30___woUId {
  margin-bottom: 30px !important;
}

.RequestLmnPopup-module__m-b-32___yfior {
  margin-bottom: 32px !important;
}

.RequestLmnPopup-module__m-b-40___yaFSL {
  margin-bottom: 40px !important;
}

.RequestLmnPopup-module__m-t-2___z4BTn {
  margin-top: 2px !important;
}

.RequestLmnPopup-module__m-t-3___KtWx7 {
  margin-top: 3px !important;
}

.RequestLmnPopup-module__m-t-4___RHfso {
  margin-top: 4px !important;
}

.RequestLmnPopup-module__m-t-5___xg5ny {
  margin-top: 5px !important;
}

.RequestLmnPopup-module__m-t-8___ZaVHK {
  margin-top: 8px !important;
}

.RequestLmnPopup-module__m-t-10___cPQ4t {
  margin-top: 10px !important;
}

.RequestLmnPopup-module__m-t-15___PqoXM {
  margin-top: 15px !important;
}

.RequestLmnPopup-module__m-t-16___meqsp {
  margin-top: 16px !important;
}

.RequestLmnPopup-module__m-t-20___i4Isf {
  margin-top: 20px !important;
}

.RequestLmnPopup-module__m-t-22___lCHpB {
  margin-top: 22px !important;
}

.RequestLmnPopup-module__m-t-30___GQ24T {
  margin-top: 30px !important;
}

.RequestLmnPopup-module__m-t-32___SVzVG {
  margin-top: 32px !important;
}

.RequestLmnPopup-module__m-l-auto___zYP2F {
  margin-left: auto !important;
}

.RequestLmnPopup-module__m-l-4___IDAr2 {
  margin-left: 4px !important;
}

.RequestLmnPopup-module__m-l-5___jNpTN {
  margin-left: 5px !important;
}

.RequestLmnPopup-module__m-l-6___IZA19 {
  margin-left: 6px !important;
}

.RequestLmnPopup-module__m-l-8___lZvbl {
  margin-left: 8px !important;
}

.RequestLmnPopup-module__m-l-10___h_2Nq {
  margin-left: 10px !important;
}

.RequestLmnPopup-module__m-l-16___IyWzF {
  margin-left: 16px !important;
}

.RequestLmnPopup-module__m-l-20___hodXX {
  margin-left: 20px !important;
}

.RequestLmnPopup-module__m-l-24___RhhHw {
  margin-left: 24px !important;
}

.RequestLmnPopup-module__m-l-30___AAqJX {
  margin-left: 30px !important;
}

.RequestLmnPopup-module__m-l-35___XU2oB {
  margin-left: 35px !important;
}

.RequestLmnPopup-module__m-l-40___vcUFW {
  margin-left: 40px !important;
}

.RequestLmnPopup-module__m-r-8___LqyXf {
  margin-right: 8px !important;
}

.RequestLmnPopup-module__m-r-10___r9fVF {
  margin-right: 10px !important;
}

.RequestLmnPopup-module__m-r-16___V_w4N {
  margin-right: 16px !important;
}

.RequestLmnPopup-module__m-r-20___gPyMO {
  margin-right: 20px !important;
}

.RequestLmnPopup-module__m-r-24___gfGlo {
  margin-right: 24px !important;
}

.RequestLmnPopup-module__m-r-30___R067R {
  margin-right: 30px !important;
}

.RequestLmnPopup-module__m-r-40___tKR9x {
  margin-right: 40px !important;
}

.RequestLmnPopup-module__border-r-3___M_6rk {
  border-radius: 3px !important;
}

.RequestLmnPopup-module__border-r-4___T_3iw {
  border-radius: 4px !important;
}

.RequestLmnPopup-module__border-r-6___UlmxN {
  border-radius: 6px !important;
}

.RequestLmnPopup-module__border-r-10___FSmON {
  border-radius: 10px !important;
}

.RequestLmnPopup-module__border-r-12___kYqs2 {
  border-radius: 12px !important;
}

.RequestLmnPopup-module__border-r-16___vfL6A {
  border-radius: 16px !important;
}

.RequestLmnPopup-module__border-r-50___yrP9u {
  border-radius: 50% !important;
}

.RequestLmnPopup-module__primary-border___fe6CY {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.RequestLmnPopup-module__primary-border-b___roG2P {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.RequestLmnPopup-module__primary-border-t___bqIYb {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.RequestLmnPopup-module__primary-border-l___vtiiS {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.RequestLmnPopup-module__primary-border-r___YA_Op {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.RequestLmnPopup-module__secondary-border___gIY28 {
  border: 1px solid #637768;
}

.RequestLmnPopup-module__secondary-border-b___y7ylL {
  border-bottom: 1px solid #637768;
}

.RequestLmnPopup-module__secondary-border-t___Lxz4o {
  border-top: 1px solid #637768;
}

.RequestLmnPopup-module__secondary-border-l___kJ8LO {
  border-left: 1px solid #637768;
}

.RequestLmnPopup-module__secondary-border-r___r_7ND {
  border-right: 1px solid #637768;
}

.RequestLmnPopup-module__gap-0___v8hMk {
  gap: 0 !important;
}

.RequestLmnPopup-module__gap-2___vIdDq {
  gap: 2px !important;
}

.RequestLmnPopup-module__gap-4___iMTuw {
  gap: 4px !important;
}

.RequestLmnPopup-module__gap-5___Xr0AD {
  gap: 5px !important;
}

.RequestLmnPopup-module__gap-6___EsuZW {
  gap: 6px !important;
}

.RequestLmnPopup-module__gap-8___DmaWX {
  gap: 8px !important;
}

.RequestLmnPopup-module__gap-10___xFoHl {
  gap: 10px !important;
}

.RequestLmnPopup-module__gap-12___Cz7Mc {
  gap: 12px !important;
}

.RequestLmnPopup-module__gap-14___vpmGJ {
  gap: 14px !important;
}

.RequestLmnPopup-module__gap-16___uK1D1 {
  gap: 16px !important;
}

.RequestLmnPopup-module__gap-18___YUaaa {
  gap: 18px !important;
}

.RequestLmnPopup-module__gap-20___m9d7v {
  gap: 20px !important;
}

.RequestLmnPopup-module__gap-24___CeWiQ {
  gap: 24px !important;
}

.RequestLmnPopup-module__gap-26___PH0Xx {
  gap: 26px !important;
}

.RequestLmnPopup-module__gap-30___iL4NG {
  gap: 30px !important;
}

.RequestLmnPopup-module__gap-32___qRm6e {
  gap: 32px !important;
}

.RequestLmnPopup-module__gap-40___nBMaq {
  gap: 40px !important;
}

.RequestLmnPopup-module__gap-50____E5dh {
  gap: 50px !important;
}

.RequestLmnPopup-module__flex-1___RDnNd {
  flex: 1;
}

.RequestLmnPopup-module__flex-none___GHv3C {
  flex: none !important;
}

.RequestLmnPopup-module__flex-column___PxAQ0 {
  display: flex;
  flex-direction: column !important;
}

.RequestLmnPopup-module__flex-row___HDjYA {
  display: flex;
  flex-direction: row !important;
}

.RequestLmnPopup-module__vertically-centered___tJrta {
  display: flex;
  align-items: center !important;
}

.RequestLmnPopup-module__horizontally-centered___agLXL {
  display: flex;
  justify-content: center !important;
}

.RequestLmnPopup-module__horizontally-end___QQHxN {
  display: flex;
  justify-content: end !important;
}

.RequestLmnPopup-module__vertically-start___h_iY7 {
  display: flex;
  align-items: start !important;
}

.RequestLmnPopup-module__space-between___CX2AN {
  display: flex;
  justify-content: space-between !important;
}

.RequestLmnPopup-module__flex-wrap___Zh7FT {
  flex-wrap: wrap !important;
}

.RequestLmnPopup-module__height-100___uCar0 {
  height: 100%;
}

.RequestLmnPopup-module__width-50___rqkLk {
  width: 50% !important;
}

.RequestLmnPopup-module__width-100___CmhHl {
  width: 100%;
}

.RequestLmnPopup-module__cursor-pointer___dr4__ {
  cursor: pointer;
}

.RequestLmnPopup-module__cursor-not-allowed___q17bh {
  cursor: not-allowed !important;
}

.RequestLmnPopup-module__absolute-centered___lz9U8 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.RequestLmnPopup-module__absolute___zn8vz {
  position: absolute;
}

.RequestLmnPopup-module__relative___rt36f {
  position: relative;
}

.RequestLmnPopup-module__fixed___tkbje {
  position: fixed;
}

.RequestLmnPopup-module__visible___Ashh0 {
  opacity: 1;
}

.RequestLmnPopup-module__invisible___Kmn5j {
  opacity: 0;
}

.RequestLmnPopup-module__col-90___ousoj {
  width: 90% !important;
}

.RequestLmnPopup-module__col-auto___w5_OR {
  width: auto !important;
}

.RequestLmnPopup-module__medical-tabs___M201F {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.RequestLmnPopup-module__medical-table-new___v3YCK {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.RequestLmnPopup-module__medical-table-new___v3YCK:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RequestLmnPopup-module__medical-table-new___v3YCK::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RequestLmnPopup-module__medical-table-new___v3YCK::-webkit-scrollbar-track {
  display: none;
}
.RequestLmnPopup-module__medical-table-new___v3YCK.RequestLmnPopup-module__no-pagination___UoWXr {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.RequestLmnPopup-module__medical-table-new___v3YCK.RequestLmnPopup-module__no-pagination___UoWXr:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RequestLmnPopup-module__medical-table-new___v3YCK.RequestLmnPopup-module__no-pagination___UoWXr::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RequestLmnPopup-module__medical-table-new___v3YCK.RequestLmnPopup-module__no-pagination___UoWXr::-webkit-scrollbar-track {
  display: none;
}

.RequestLmnPopup-module__medical-table-empty___Fjcon {
  padding: 14px 40px !important;
}

.RequestLmnPopup-module__icon-btn___fwo_K {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.RequestLmnPopup-module__search-icon___ep1Yu {
  width: 24px;
  height: 24px;
  align-self: center;
}

.RequestLmnPopup-module__disable-select___aUrdl {
  user-select: none;
}

.RequestLmnPopup-module__break-word___Kgta0 {
  word-break: break-word;
}

.RequestLmnPopup-module__popup-clear-btn___i7irJ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.RequestLmnPopup-module__scroll-m-b-20___xdAsW {
  scroll-margin-bottom: 20px;
}

.RequestLmnPopup-module__label___QA4jB {
  color: #637768;
}

.RequestLmnPopup-module__grid___HBaLH {
  display: grid;
  row-gap: 15px;
  column-gap: 40px;
  grid-template-columns: 1fr 1fr;
}

.RequestLmnPopup-module__error___u3aIZ {
  color: #c56836;
  height: 4px;
}

.RequestLmnPopup-module__buttonsContainer___YkJpf {
  gap: 16px;
  display: flex;
  padding: 30px;
  justify-content: end;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.RequestLmnPopup-module__wrapper___b2eue {
  padding: 25px 30px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/RequestLmnPopup/RequestLmnPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;AA8pBF;;AA3pBA;EACE,cAAA;EACA,WAAA;AA8pBF;;AA3pBA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;EACA,2CAAA;AA8pBF;;AA3pBA;EACE,kBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.label {\n  color: get-color(greenNew, medium-dark);\n}\n\n.grid {\n  display: grid;\n  row-gap: 15px;\n  column-gap: 40px;\n  grid-template-columns: 1fr 1fr;\n}\n\n.error {\n  color: get-color(orangeNew, dark);\n  height: 4px;\n}\n\n.buttonsContainer {\n  gap: 16px;\n  display: flex;\n  padding: 30px;\n  justify-content: end;\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.wrapper {\n  padding: 25px 30px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `RequestLmnPopup-module__font-s-10___dFAhz`,
	"fontS12": `RequestLmnPopup-module__font-s-12___iI771`,
	"fontS13": `RequestLmnPopup-module__font-s-13___Jxykm`,
	"fontS14": `RequestLmnPopup-module__font-s-14___wmuua`,
	"fontS15": `RequestLmnPopup-module__font-s-15___AQCuv`,
	"fontS16": `RequestLmnPopup-module__font-s-16___pU_V1`,
	"fontS18": `RequestLmnPopup-module__font-s-18___yyqpA`,
	"fontS20": `RequestLmnPopup-module__font-s-20___JQFTF`,
	"fontS22": `RequestLmnPopup-module__font-s-22___YjXM7`,
	"fontS28": `RequestLmnPopup-module__font-s-28___wZVj5`,
	"fontW400": `RequestLmnPopup-module__font-w-400___TXbmn`,
	"fontW500": `RequestLmnPopup-module__font-w-500___sTMX7`,
	"fontW600": `RequestLmnPopup-module__font-w-600___UXlQ6`,
	"fontW700": `RequestLmnPopup-module__font-w-700___ZbTq9`,
	"p5": `RequestLmnPopup-module__p-5___Mi_et`,
	"p12": `RequestLmnPopup-module__p-12___tSaZV`,
	"p16": `RequestLmnPopup-module__p-16___JGsEg`,
	"p30": `RequestLmnPopup-module__p-30___qPvSH`,
	"pB0": `RequestLmnPopup-module__p-b-0___c9VLg`,
	"pB5": `RequestLmnPopup-module__p-b-5___Q06KB`,
	"pB10": `RequestLmnPopup-module__p-b-10___khcQJ`,
	"pB12": `RequestLmnPopup-module__p-b-12___zlfYd`,
	"pB16": `RequestLmnPopup-module__p-b-16___a_CCo`,
	"pB18": `RequestLmnPopup-module__p-b-18___UpclB`,
	"pB20": `RequestLmnPopup-module__p-b-20___esDls`,
	"pB25": `RequestLmnPopup-module__p-b-25___yS9kL`,
	"pB30": `RequestLmnPopup-module__p-b-30___pQp_r`,
	"pB50": `RequestLmnPopup-module__p-b-50___JOcHK`,
	"pT0": `RequestLmnPopup-module__p-t-0___ULhGW`,
	"pT12": `RequestLmnPopup-module__p-t-12___JajYj`,
	"pT16": `RequestLmnPopup-module__p-t-16___vujxy`,
	"pT18": `RequestLmnPopup-module__p-t-18___VhtrW`,
	"pT20": `RequestLmnPopup-module__p-t-20___KRYCb`,
	"pT30": `RequestLmnPopup-module__p-t-30___t9qR4`,
	"pT40": `RequestLmnPopup-module__p-t-40___E09mv`,
	"pT50": `RequestLmnPopup-module__p-t-50___aN5qo`,
	"pL20": `RequestLmnPopup-module__p-l-20___X91B7`,
	"pL30": `RequestLmnPopup-module__p-l-30___wpY0_`,
	"pL40": `RequestLmnPopup-module__p-l-40___SbmPs`,
	"pR16": `RequestLmnPopup-module__p-r-16___Fk5UQ`,
	"pR20": `RequestLmnPopup-module__p-r-20____Awkt`,
	"pR30": `RequestLmnPopup-module__p-r-30___yTT21`,
	"pR50": `RequestLmnPopup-module__p-r-50___LqQEg`,
	"pR60": `RequestLmnPopup-module__p-r-60___w8rXt`,
	"mB1": `RequestLmnPopup-module__m-b-1___kwF08`,
	"mB2": `RequestLmnPopup-module__m-b-2___jRQF9`,
	"mB6": `RequestLmnPopup-module__m-b-6___qtXhE`,
	"mB8": `RequestLmnPopup-module__m-b-8___qqKma`,
	"mB10": `RequestLmnPopup-module__m-b-10___FZkCI`,
	"mB14": `RequestLmnPopup-module__m-b-14___Dnoru`,
	"mB16": `RequestLmnPopup-module__m-b-16___cHTaf`,
	"mB20": `RequestLmnPopup-module__m-b-20___ALVhy`,
	"mB22": `RequestLmnPopup-module__m-b-22___nx93H`,
	"mB24": `RequestLmnPopup-module__m-b-24___PQYb5`,
	"mB30": `RequestLmnPopup-module__m-b-30___woUId`,
	"mB32": `RequestLmnPopup-module__m-b-32___yfior`,
	"mB40": `RequestLmnPopup-module__m-b-40___yaFSL`,
	"mT2": `RequestLmnPopup-module__m-t-2___z4BTn`,
	"mT3": `RequestLmnPopup-module__m-t-3___KtWx7`,
	"mT4": `RequestLmnPopup-module__m-t-4___RHfso`,
	"mT5": `RequestLmnPopup-module__m-t-5___xg5ny`,
	"mT8": `RequestLmnPopup-module__m-t-8___ZaVHK`,
	"mT10": `RequestLmnPopup-module__m-t-10___cPQ4t`,
	"mT15": `RequestLmnPopup-module__m-t-15___PqoXM`,
	"mT16": `RequestLmnPopup-module__m-t-16___meqsp`,
	"mT20": `RequestLmnPopup-module__m-t-20___i4Isf`,
	"mT22": `RequestLmnPopup-module__m-t-22___lCHpB`,
	"mT30": `RequestLmnPopup-module__m-t-30___GQ24T`,
	"mT32": `RequestLmnPopup-module__m-t-32___SVzVG`,
	"mLAuto": `RequestLmnPopup-module__m-l-auto___zYP2F`,
	"mL4": `RequestLmnPopup-module__m-l-4___IDAr2`,
	"mL5": `RequestLmnPopup-module__m-l-5___jNpTN`,
	"mL6": `RequestLmnPopup-module__m-l-6___IZA19`,
	"mL8": `RequestLmnPopup-module__m-l-8___lZvbl`,
	"mL10": `RequestLmnPopup-module__m-l-10___h_2Nq`,
	"mL16": `RequestLmnPopup-module__m-l-16___IyWzF`,
	"mL20": `RequestLmnPopup-module__m-l-20___hodXX`,
	"mL24": `RequestLmnPopup-module__m-l-24___RhhHw`,
	"mL30": `RequestLmnPopup-module__m-l-30___AAqJX`,
	"mL35": `RequestLmnPopup-module__m-l-35___XU2oB`,
	"mL40": `RequestLmnPopup-module__m-l-40___vcUFW`,
	"mR8": `RequestLmnPopup-module__m-r-8___LqyXf`,
	"mR10": `RequestLmnPopup-module__m-r-10___r9fVF`,
	"mR16": `RequestLmnPopup-module__m-r-16___V_w4N`,
	"mR20": `RequestLmnPopup-module__m-r-20___gPyMO`,
	"mR24": `RequestLmnPopup-module__m-r-24___gfGlo`,
	"mR30": `RequestLmnPopup-module__m-r-30___R067R`,
	"mR40": `RequestLmnPopup-module__m-r-40___tKR9x`,
	"borderR3": `RequestLmnPopup-module__border-r-3___M_6rk`,
	"borderR4": `RequestLmnPopup-module__border-r-4___T_3iw`,
	"borderR6": `RequestLmnPopup-module__border-r-6___UlmxN`,
	"borderR10": `RequestLmnPopup-module__border-r-10___FSmON`,
	"borderR12": `RequestLmnPopup-module__border-r-12___kYqs2`,
	"borderR16": `RequestLmnPopup-module__border-r-16___vfL6A`,
	"borderR50": `RequestLmnPopup-module__border-r-50___yrP9u`,
	"primaryBorder": `RequestLmnPopup-module__primary-border___fe6CY`,
	"primaryBorderB": `RequestLmnPopup-module__primary-border-b___roG2P`,
	"primaryBorderT": `RequestLmnPopup-module__primary-border-t___bqIYb`,
	"primaryBorderL": `RequestLmnPopup-module__primary-border-l___vtiiS`,
	"primaryBorderR": `RequestLmnPopup-module__primary-border-r___YA_Op`,
	"secondaryBorder": `RequestLmnPopup-module__secondary-border___gIY28`,
	"secondaryBorderB": `RequestLmnPopup-module__secondary-border-b___y7ylL`,
	"secondaryBorderT": `RequestLmnPopup-module__secondary-border-t___Lxz4o`,
	"secondaryBorderL": `RequestLmnPopup-module__secondary-border-l___kJ8LO`,
	"secondaryBorderR": `RequestLmnPopup-module__secondary-border-r___r_7ND`,
	"gap0": `RequestLmnPopup-module__gap-0___v8hMk`,
	"gap2": `RequestLmnPopup-module__gap-2___vIdDq`,
	"gap4": `RequestLmnPopup-module__gap-4___iMTuw`,
	"gap5": `RequestLmnPopup-module__gap-5___Xr0AD`,
	"gap6": `RequestLmnPopup-module__gap-6___EsuZW`,
	"gap8": `RequestLmnPopup-module__gap-8___DmaWX`,
	"gap10": `RequestLmnPopup-module__gap-10___xFoHl`,
	"gap12": `RequestLmnPopup-module__gap-12___Cz7Mc`,
	"gap14": `RequestLmnPopup-module__gap-14___vpmGJ`,
	"gap16": `RequestLmnPopup-module__gap-16___uK1D1`,
	"gap18": `RequestLmnPopup-module__gap-18___YUaaa`,
	"gap20": `RequestLmnPopup-module__gap-20___m9d7v`,
	"gap24": `RequestLmnPopup-module__gap-24___CeWiQ`,
	"gap26": `RequestLmnPopup-module__gap-26___PH0Xx`,
	"gap30": `RequestLmnPopup-module__gap-30___iL4NG`,
	"gap32": `RequestLmnPopup-module__gap-32___qRm6e`,
	"gap40": `RequestLmnPopup-module__gap-40___nBMaq`,
	"gap50": `RequestLmnPopup-module__gap-50____E5dh`,
	"flex1": `RequestLmnPopup-module__flex-1___RDnNd`,
	"flexNone": `RequestLmnPopup-module__flex-none___GHv3C`,
	"flexColumn": `RequestLmnPopup-module__flex-column___PxAQ0`,
	"flexRow": `RequestLmnPopup-module__flex-row___HDjYA`,
	"verticallyCentered": `RequestLmnPopup-module__vertically-centered___tJrta`,
	"horizontallyCentered": `RequestLmnPopup-module__horizontally-centered___agLXL`,
	"horizontallyEnd": `RequestLmnPopup-module__horizontally-end___QQHxN`,
	"verticallyStart": `RequestLmnPopup-module__vertically-start___h_iY7`,
	"spaceBetween": `RequestLmnPopup-module__space-between___CX2AN`,
	"flexWrap": `RequestLmnPopup-module__flex-wrap___Zh7FT`,
	"height100": `RequestLmnPopup-module__height-100___uCar0`,
	"width50": `RequestLmnPopup-module__width-50___rqkLk`,
	"width100": `RequestLmnPopup-module__width-100___CmhHl`,
	"cursorPointer": `RequestLmnPopup-module__cursor-pointer___dr4__`,
	"cursorNotAllowed": `RequestLmnPopup-module__cursor-not-allowed___q17bh`,
	"absoluteCentered": `RequestLmnPopup-module__absolute-centered___lz9U8`,
	"absolute": `RequestLmnPopup-module__absolute___zn8vz`,
	"relative": `RequestLmnPopup-module__relative___rt36f`,
	"fixed": `RequestLmnPopup-module__fixed___tkbje`,
	"visible": `RequestLmnPopup-module__visible___Ashh0`,
	"invisible": `RequestLmnPopup-module__invisible___Kmn5j`,
	"col90": `RequestLmnPopup-module__col-90___ousoj`,
	"colAuto": `RequestLmnPopup-module__col-auto___w5_OR`,
	"medicalTabs": `RequestLmnPopup-module__medical-tabs___M201F`,
	"medicalTableNew": `RequestLmnPopup-module__medical-table-new___v3YCK`,
	"noPagination": `RequestLmnPopup-module__no-pagination___UoWXr`,
	"medicalTableEmpty": `RequestLmnPopup-module__medical-table-empty___Fjcon`,
	"iconBtn": `RequestLmnPopup-module__icon-btn___fwo_K`,
	"searchIcon": `RequestLmnPopup-module__search-icon___ep1Yu`,
	"disableSelect": `RequestLmnPopup-module__disable-select___aUrdl`,
	"breakWord": `RequestLmnPopup-module__break-word___Kgta0`,
	"popupClearBtn": `RequestLmnPopup-module__popup-clear-btn___i7irJ`,
	"scrollMB20": `RequestLmnPopup-module__scroll-m-b-20___xdAsW`,
	"label": `RequestLmnPopup-module__label___QA4jB`,
	"grid": `RequestLmnPopup-module__grid___HBaLH`,
	"error": `RequestLmnPopup-module__error___u3aIZ`,
	"buttonsContainer": `RequestLmnPopup-module__buttonsContainer___YkJpf`,
	"wrapper": `RequestLmnPopup-module__wrapper___b2eue`
};
module.exports = ___CSS_LOADER_EXPORT___;
